import Box from "@mui/material/Box";
import FilterIcon from '@mui/icons-material/Filter';
import Filter1Icon from '@mui/icons-material/Filter1';
import Filter2Icon from '@mui/icons-material/Filter2';
import Filter3Icon from '@mui/icons-material/Filter3';
import Filter4Icon from '@mui/icons-material/Filter4';
import Filter5Icon from '@mui/icons-material/Filter5';
import Filter6Icon from '@mui/icons-material/Filter6';
import Filter7Icon from '@mui/icons-material/Filter7';
import Filter8Icon from '@mui/icons-material/Filter8';
import Filter9PlusIcon from '@mui/icons-material/Filter9Plus';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Button, List, Tooltip } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import MuiDrawer from '@mui/material/Drawer';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { styled } from '@mui/material/styles';
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ColorConstants from '../defaults/ColorConstants';
import FieldNames from '../defaults/FieldNames.json';
import ActionCategoryAssociations from '../defaults/ActionCategoryAssociations.json'
import { useIFPRSGlobalContext } from '../IFPRSGlobalContext';
import { setDefinitionExpression } from '../redux/slices/filterSlice';
import ErrorService from '../services/ErrorService';
import FeatureService from '../services/FeatureService';
import FilterPopulationService from '../services/FilterPopulationService';
import CustomFilterList from './arcgisFilter/components/CustomFilterList';
import FiltersContainer from './discovery/filter/FiltersContainer';
import "./discovery/list/TreatmentActivityList.css";
import { setViewingActions, setViewingProjects } from "../redux/slices/menuSlice";

const drawerWidth = 550;

const openedMixin = (theme, headerheight) => ({
  width: drawerWidth,
  top: headerheight + "px",
  left: 'auto',
  backgroundColor: ColorConstants.AvatarBackgroundColor,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  overflowY: 'hidden'
});

const closedMixin = (theme, headerheight) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  //overflowY: 'hidden',
  top: headerheight + "px",
  backgroundColor: ColorConstants.AvatarBackgroundColor,
  left: 'auto',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: theme.spacing(0, 1),
  height: '48px !important',
  backgroundColor: ColorConstants.WhiteAlien,
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open, headerheight }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme, headerheight),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme, headerheight),
    }),
  }),
);

export default function FilterList({ headerheight }) {

  const { filterListOpen, setFilterListOpen } = useIFPRSGlobalContext();
  const handleToggleDrawer = () => {
    var wasOpen = filterListOpen;
    setFilterListOpen(!wasOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Drawer variant="permanent" open={filterListOpen} headerheight={headerheight}>
        <DrawerHeader style={{ justifyContent: 'space-between', minHeight: 60}}>
          <IconButton onClick={handleToggleDrawer} >
            {filterListOpen ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
      </Drawer>
    </Box>
  );
}